import Link from 'next/link'
import Image from 'next/image'
import { useState } from 'react'
import { Logo } from '~shared/components/logo'
import { cn } from '~shared/utils/cn'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'
import { getFooterData } from '~shared/api/footer/getFooterData'
import { PATHS } from '~shared/constants/paths'
import { sortBasedOnKey } from '~shared/utils/sortBasedOnKey'
import { Button } from '~shared/components/button-v2'
import { LeadFormDialog } from '~widgets/lead-form/components/lead-form-dialog'

const TelegramIcon = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='16' fill='white' fillOpacity='0.2' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.69847 19.4104C14.8664 17.1588 18.3125 15.6744 20.0367 14.9572C24.9598 12.9096 25.9828 12.5539 26.6495 12.5421C26.7962 12.5395 27.1241 12.5759 27.3365 12.7482C27.5158 12.8937 27.5652 13.0903 27.5888 13.2283C27.6124 13.3663 27.6418 13.6806 27.6184 13.9262C27.3516 16.7293 26.1973 23.5317 25.61 26.6713C25.3615 27.9997 24.8722 28.4451 24.3985 28.4887C23.369 28.5835 22.5873 27.8084 21.5902 27.1548C20.03 26.132 19.1485 25.4954 17.634 24.4973C15.8838 23.344 17.0184 22.71 18.0159 21.674C18.2769 21.4029 22.8127 17.2772 22.9005 16.9029C22.9115 16.8561 22.9217 16.6817 22.8181 16.5895C22.7144 16.4974 22.5614 16.5289 22.451 16.554C22.2945 16.5895 19.802 18.2369 14.9735 21.4963C14.266 21.9821 13.6252 22.2188 13.051 22.2064C12.4181 22.1928 11.2005 21.8486 10.2954 21.5543C9.18518 21.1935 8.30283 21.0027 8.37966 20.3898C8.41968 20.0706 8.85929 19.7441 9.69847 19.4104Z'
      fill='white'
    />
  </svg>
)

const VkIcon = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='16' fill='white' fillOpacity='0.2' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.7854 26.3549H19.9808C19.9808 26.3549 20.3419 26.3134 20.5264 26.1058C20.6961 25.915 20.6907 25.557 20.6907 25.557C20.6907 25.557 20.6673 23.8804 21.4116 23.6336C22.1457 23.3902 23.0881 25.2538 24.0869 25.9705C24.8422 26.5126 25.4162 26.394 25.4162 26.394L28.0871 26.3549C28.0871 26.3549 29.4842 26.2648 28.8217 25.1167C28.7675 25.0229 28.4358 24.2674 26.8358 22.7151C25.1609 21.0904 25.3854 21.3533 27.4028 18.543C28.6313 16.8315 29.1224 15.7867 28.969 15.3392C28.8228 14.9129 27.9191 15.0255 27.9191 15.0255L24.9118 15.0449C24.9118 15.0449 24.6887 15.0132 24.5235 15.1166C24.3619 15.2176 24.2581 15.4538 24.2581 15.4538C24.2581 15.4538 23.782 16.7781 23.1474 17.9045C21.8083 20.281 21.2728 20.4068 21.0539 20.259C20.5447 19.9151 20.6719 18.8775 20.6719 18.1401C20.6719 15.8369 21.0062 14.8766 20.0211 14.628C19.6942 14.5456 19.4534 14.491 18.6174 14.4821C17.5443 14.4707 16.6363 14.4856 16.122 14.7489C15.7799 14.924 15.5159 15.3141 15.6768 15.3366C15.8756 15.3643 16.3256 15.4636 16.5642 15.8029C16.8725 16.2412 16.8617 17.2252 16.8617 17.2252C16.8617 17.2252 17.0388 19.9365 16.4482 20.2732C16.0429 20.5041 15.4868 20.0326 14.2929 17.8765C13.6813 16.772 13.2194 15.5511 13.2194 15.5511C13.2194 15.5511 13.1305 15.323 12.9716 15.2008C12.7789 15.0529 12.5096 15.006 12.5096 15.006L9.65187 15.0255C9.65187 15.0255 9.22298 15.038 9.06536 15.233C8.92514 15.4066 9.05416 15.7651 9.05416 15.7651C9.05416 15.7651 11.2913 21.2359 13.8247 23.9928C16.1479 26.5209 18.7854 26.3549 18.7854 26.3549Z'
      fill='white'
    />
  </svg>
)

const DzenIcon = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='16' fill='white' fillOpacity='0.2' />
    <g clipPath='url(#clip0_24551_11743)'>
      <path
        d='M30.8936 19.5125C30.8936 19.4053 30.8065 19.3166 30.6993 19.3116C26.8543 19.166 24.5143 18.6755 22.8772 17.0385C21.2368 15.398 20.748 13.0563 20.6024 9.20296C20.599 9.09583 20.5103 9.00879 20.4015 9.00879H19.9529C19.8458 9.00879 19.7571 9.09583 19.7521 9.20296C19.6064 13.0546 19.1176 15.398 17.4772 17.0385C15.8385 18.6772 13.5 19.166 9.65511 19.3116C9.54798 19.315 9.46094 19.4037 9.46094 19.5125V19.9611C9.46094 20.0682 9.54798 20.1569 9.65511 20.162C13.5 20.3076 15.8402 20.798 17.4772 22.4351C19.1143 24.0722 19.6031 26.4073 19.7504 30.2454C19.7537 30.3526 19.8424 30.4397 19.9512 30.4397H20.4015C20.5087 30.4397 20.5974 30.3526 20.6024 30.2454C20.7497 26.4073 21.2385 24.0722 22.8755 22.4351C24.5143 20.7964 26.8527 20.3076 30.6976 20.162C30.8048 20.1586 30.8919 20.0699 30.8919 19.9611V19.5125H30.8936Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_24551_11743'>
        <rect
          width='21.6'
          height='21.6'
          fill='white'
          transform='translate(9.39844 9)'
        />
      </clipPath>
    </defs>
  </svg>
)

const IMG_LICENCE_NUMBER = '№1207700217977'

export interface FooterProps {
  className?: string
  data: Awaited<ReturnType<typeof getFooterData>>
}

export const Footer = (props: FooterProps) => {
  const { className, data } = props
  const [isOpen, setIsOpen] = useState(false)

  const address = 'г. Москва,\nул.\u00A0Новочеремушкинская 71/32'
  const email = 'info@mitm.institute'
  const countryNumber = '8 800 444-81-38'
  const capitalNumber = '+7 495 648-62-26'
  const companyName = 'Московский Институт Технологий и Управления'
  const currentYear = new Date().getFullYear()

  const programs = [
    { name: 'Бакалавриат', slug: '/programs/bakalavriat' },
    { name: 'Магистратура', slug: '/programs/magistratura' },
    { name: 'Курсы ДПО', slug: '/programs/kursy' },
    { name: 'Колледж', slug: '/programs/college' },
    { name: 'MBA', slug: '/mba' },
    { name: 'Мероприятия', slug: '/meropriyatiya' }
  ]

  const directions =
    data?.faculties
      ?.map(faculty => ({
        ...faculty,
        slug: `${PATHS.front.general.programs.ru}${
          faculty?.slug
            ? `--${PATHS.front.general.faculty.ru}--${faculty?.slug}`
            : ''
        }`
      }))
      ?.filter(faculty => faculty?.slug) || []

  // На lg+ две колонки, на md и ниже — одна
  const directionsCol1 = directions.slice(0, 8)
  const directionsCol2 = directions.slice(8)

  const aboutLinks = sortBasedOnKey(
    [
      { name: 'Журнал', slug: '/journal', rank: 0 },
      { name: 'Контакты', slug: PATHS.front.contact.index, rank: 1 }
    ],
    'rank'
  )

  const docs = [
    {
      id: 1,
      title: 'Государственная лицензия',
      number: IMG_LICENCE_NUMBER,
      link: 'https://islod.obrnadzor.gov.ru/rlic/details/0B100E0A-0A0B-110B-0D10-0E13110C0C111010110E/' as `http${string}`,
    },
    {
      id: 2,
      title: 'Государственная аккредитация',
      number: 'от 9.02.2026',
      link: '/assets/docs/Аккредитация МИТМ.pdf' as `/${string}`,
    }
  ]

  const linkCls =
    'text-[14px] text-[#888888] hover:text-white transition-colors leading-[1.3]'
  const headingCls = 'text-[16px] font-medium text-white leading-[1.2]'
  const listCls = 'flex flex-col gap-[16px]'

  return (
    <footer className={cn('bg-black', className)}>
      <LeadFormDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        buttonText='Отправить'
      />

      <div className='container pt-20 container-slim'>
        <Logo id='footer' className='text-primary' />

        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-[1fr_1fr_0.7fr_1.3fr_1fr] gap-x-[16px] lg:gap-x-[32px] gap-y-[32px] lg:gap-y-[80px] mt-[70px] mb-[60px]'>
          {/* 1. Приёмная комиссия — mobile:order-1, md:order-1, lg:order-none */}
          <div className='flex flex-col gap-[16px] md:gap-[32px] order-1 lg:order-none'>
            <p className='text-white lg:text-[20px]'>Приемная комиссия</p>
            <div className='flex flex-col gap-[4px]'>
              <p className='text-[12px] text-[#888888] leading-[1.4]'>
                Бесплатно по России
              </p>
              <a
                href={`tel:${countryNumber.replace(/[^\d+]/g, '')}`}
                className='lg:text-[20px] font-medium text-white leading-[1.2] tracking-[-0.5px]'>
                {countryNumber}
              </a>
            </div>
            <div className='flex flex-col gap-[4px]'>
              <p className='text-[12px] text-[#888888] leading-[1.4]'>
                Бесплатно по Москве
              </p>
              <a
                href={`tel:${capitalNumber.replace(/[^\d+]/g, '')}`}
                className='lg:text-[20px] font-medium text-white leading-[1.2] tracking-[-0.5px]'>
                {capitalNumber}
              </a>
            </div>
            <Button
              onClick={() => setIsOpen(true)}
              className='w-fit bg-[#4C5BFF] hover:bg-[#3D4AE0] text-white text-[14px] lg:text-[16px] font-medium px-[14px] lg:px-[28px] h-[45px] py-[8px] md:py-[14px] rounded-[12px] transition-colors'>
              Обратный звонок
            </Button>
          </div>

          {/* 2. Программы — mobile:order-2, md:order-2 */}
          <div className='flex flex-col gap-[24px] order-3 lg:order-none'>
            <p className={headingCls}>Программы</p>
            <ul className={listCls}>
              {programs.map(link => (
                <li key={link.name}>
                  <Link prefetch={false} href={link.slug} className={linkCls}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 3. Направления кол.1 — mobile:order-4, md:order-3 */}
          <div className='flex flex-col gap-[24px] order-4 md:order-5 lg:order-none'>
            <p className={headingCls}>Направления</p>
            <ul className={listCls}>
              {/* На lg — только первая половина; на md и mobile — все направления */}
              {directionsCol1.map(link => (
                <li key={link.name}>
                  <Link
                    prefetch={false}
                    href={link.slug ?? ''}
                    className={linkCls}>
                    {replacePrepositionsWhitespaces(link.name)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 4. Направления кол.2 — только на lg+, на md/mobile скрыта */}
          <div className='flex order-6 flex-col gap-[24px] lg:order-none mt-[-60px] md:mt-0'>
            <p className={`${headingCls} invisible`}>&nbsp;</p>
            <ul className={listCls}>
              {directionsCol2.map(link => (
                <li key={link.name}>
                  <Link
                    prefetch={false}
                    href={link.slug ?? ''}
                    className={linkCls}>
                    {replacePrepositionsWhitespaces(link.name)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 5. Об институте — mobile:order-5, md:order-5 (3-я колонка 1-й строки) */}
          <div className='flex flex-col gap-[24px] order-5 md:order-3 lg:order-none'>
            <p className={headingCls}>Об институте</p>
            <ul className={listCls}>
              {aboutLinks.map(link => (
                <li key={link.name}>
                  <Link
                    prefetch={false}
                    href={link.slug ?? ''}
                    className={linkCls}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 6. Контакты — mobile:order-3, md:order-4 (1-я колонка 2-й строки) */}
          <div className='flex flex-col gap-[16px] order-2 md:order-4 lg:order-none min-w-0'>
            <p className='lg:text-[20px] font-medium text-white leading-[1.2]'>
              Контакты
            </p>
            <p
              className='text-white leading-[1.6]  text-[14px]'
              lang='ru'
              style={{
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                WebkitHyphens: 'auto'
              }}>
              {address}
            </p>
            <a
              href={`mailto:${email}`}
              className='text-white hover:text-white transition-colors text-[14px] lg:text-[16px]'>
              {email}
            </a>
            <div className='flex gap-[4px] sm:gap-[12px] mt-[8px]'>
              {[
                {
                  href: 'https://t.me/mitm_institute',
                  Icon: TelegramIcon,
                  label: 'Telegram'
                },
                {
                  href: 'https://vk.ru/mitm.institute',
                  Icon: VkIcon,
                  label: 'ВКонтакте'
                },
                {
                  href: 'https://dzen.ru/mitm?share_to=link',
                  Icon: DzenIcon,
                  label: 'Дзен'
                }
              ].map(({ href, Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label={label}
                  className='w-[40px] h-[40px] rounded-[16px] hover:bg-[#333333] flex items-center justify-center text-[#888888] hover:text-white transition-colors'>
                  <Icon />
                </a>
              ))}
            </div>
          </div>
          {/* 7. Лицензия — mobile:order-7, md:order-7 */}
          <div className='flex flex-col flex-wrap gap-x-[32px] gap-y-[20px] order-7 lg:order-none col-span-2'>
            {docs.map(doc => (
              <a
                key={doc.id}
                href={doc.link}
                target='_blank'
                rel='noopener noreferrer'
                className='flex flex-col gap-[8px] pt-[4px] group'>
                <p className='lg:text-[20px] font-medium text-white leading-[1.3] max-w-[360px]'>
                  {doc.title}
                </p>
                <p className='text-[13px] text-[#888888]'>{doc.number}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className='h-[1px] bg-[#2A2A2A]' />

        {/* Copyright row */}
        <div className='flex flex-col sm:flex-row justify-between gap-[12px] items-start sm:items-center py-[24px] text-[13px] text-[#555555]'>
          <span>
            &copy;&nbsp;{companyName},&nbsp;{currentYear}
          </span>
          <a
            href='/ofertapdf/oferta.pdf'
            className='hover:text-[#888888] transition-colors'>
            Публичная оферта
          </a>
        </div>
      </div>
    </footer>
  )
}
